<div class="container">

    <div #sentinel class="sticky-sentinel"></div>

    <p-card class="container-header-card"
              [class.is-stuck]="isStuck()">
        <div class="container-header">
            <div class="container-header-content">
                @if (navigateBack()) {
                    <p-button [text]="true" [rounded]="true" severity="secondary"
                              (click)="handleNavigateBack()">
                        <i class="pi pi-chevron-left"></i>
                    </p-button>
                }

                <ng-content select="detail-header"></ng-content>
            </div>

            <ng-content select="detail-header-action"></ng-content>

        </div>
    </p-card>


    <ng-content select="detail-body"></ng-content>
</div>
